import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 600,
      "data-sign": "finance_bill_data_add_or_edit_modal",
      "title": _vm.rowData.title
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.billDataTitleLoading
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "data-sign": "finance_bill_data_add_or_edit_form",
      "model": _vm.formData,
      "label-col": {
        span: _vm.colSpan
      },
      "wrapper-col": {
        span: 24 - _vm.colSpan
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u62AC\u5934"),
      "prop": "account_code",
      "label": _vm.t('抬头')
    }
  }, [_vm.rowData.type === _vm.$enum.common.ModalTypeEnum.EDIT && !_vm.editAccountCode ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.formData.account_code) + " " + _vm._s(_vm.formData.title))]), _c('a', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "finance_bill_data_edit_title",
      "fbu-analyse-name": $t("\u4FEE\u6539")
    },
    on: {
      "click": _vm.handleClickAccountCodeEdit
    }
  }, [_vm._v(_vm._s(_vm.t('修改')))])]) : _c('my-select', {
    staticClass: "input-item",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-search": "",
      "placeholder": _vm.t('请选择抬头')
    },
    on: {
      "change": _vm.handleAccountCodeChange
    },
    model: {
      value: _vm.formData.account_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "account_code", $$v);
      },
      expression: "formData.account_code"
    }
  }, _vm._l(_vm.billDataTitleList, function (item) {
    return _c('a-select-option', {
      key: item.account_code,
      attrs: {
        "value": item.account_code
      }
    }, [_vm._v(" " + _vm._s(item.account_code) + " " + _vm._s(item.sign_body_name) + " ")]);
  }), 1)], 1), _vm.isTaxNoRequired ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7A0E\u53F7"),
      "label": _vm.t('税号')
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.formData.tax_no)))])]) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5730\u5740"),
      "prop": "address",
      "label": _vm.t('地址')
    }
  }, [_c('my-input', {
    staticClass: "input-item",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入地址'),
      "maxLength": 256
    },
    model: {
      value: _vm.formData.address,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "address", $$v);
      },
      expression: "formData.address"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7535\u8BDD"),
      "prop": "phone",
      "label": _vm.t('电话')
    }
  }, [_c('my-input', {
    staticClass: "input-item",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入电话'),
      "maxLength": 20
    },
    model: {
      value: _vm.formData.phone,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "phone", $$v);
      },
      expression: "formData.phone"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5F00\u6237\u884C"),
      "prop": "open_bank_name",
      "label": _vm.t('开户行')
    }
  }, [_c('my-input', {
    staticClass: "input-item",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入开户行'),
      "maxLength": 100
    },
    model: {
      value: _vm.formData.open_bank_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "open_bank_name", $$v);
      },
      expression: "formData.open_bank_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u53F7"),
      "prop": "open_bank_account",
      "label": _vm.t('账号')
    }
  }, [_c('my-input', {
    staticClass: "input-item",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入账号'),
      "maxLength": 100
    },
    model: {
      value: _vm.formData.open_bank_account,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "open_bank_account", $$v);
      },
      expression: "formData.open_bank_account"
    }
  })], 1)], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-sign": "finance_bill_data_add_or_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "data-sign": "finance_bill_data_add_or_edit_save",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };